import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {
  citizenGetServicesResults
} from 'src/app/store/entities/citizens/citizens-services-result/citizens-services-result.actions';
import {
  CitizensServicesResult
} from 'src/app/store/entities/citizens/citizens-services-result/citizens-services-result.model';
import {AppState} from 'src/app/store/reducers';

@Component({
  selector: 'app-citizen-services-results',
  templateUrl: './citizen-services-results.component.html',
  styleUrls: ['./citizen-services-results.component.scss']
})
export class CitizenServicesResultsComponent implements OnInit {

  @Input() serviceUniqueId: string;
  servicesResults$:Observable<CitizensServicesResult []>;
  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private translateService: TranslateService,
  ) {

  }

  ngOnInit(): void {
    this.store.dispatch(citizenGetServicesResults({serviceUniqueId:this.serviceUniqueId}))
  }

}
